import { _DOCUMENT_ } from "constants/dom"

const getElementById = <T extends HTMLElement = HTMLElement>(id: string) => {
  return _DOCUMENT_.getElementById(id) as T | null;
}

export default getElementById;
